import {selectLoggedInArtist} from "../../../auth/authSelector";
import {select} from "redux-saga/effects";

/**
 * Safety fallback for list queries:
 * when a non-admin has no explicit artist filter, use the caller-provided
 * writable artist IDs (effective staging behavior).
 */
export function* enrichWithArtistIdListForNoAdmin(parameters) {
    const {fallbackArtistIdList, ...safeParameters} = parameters || {}
    const loggedInArtist = yield select(state => selectLoggedInArtist(state))
    const {isAdmin, CannotEdit} = loggedInArtist || {}
    if (!CannotEdit && !isAdmin && !safeParameters.artistIdList?.length) {
        const artistIdList = Array.isArray(fallbackArtistIdList) ? fallbackArtistIdList : []
        return {...safeParameters, artistIdList}
    }
    return safeParameters
}
